import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { CustomLoginForgotPasswordInterface } from 'common/types/entities/CustomLoginForgotPasswordInterface'
import i18n from 'i18next'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { generateBaseEntity } from '../utils/generate-base-entity'

export function createForgotPassword({
  locale,
  parentId,
  masterBlockId,
}: {
  parentId: string
  masterBlockId?: MasterBlockIdType
  locale: string
}): CustomLoginForgotPasswordInterface {
  const fixedT = i18n.getFixedT(locale)
  const forgotPasswordString = fixedT(
    'entities.member_access.request.default_headline',
  )
  return {
    ...generateBaseEntity(
      EntityTypeEnum.CustomLoginForgotPassword,
      parentId,
      masterBlockId,
    ),
    fontSize: 16,
    mobileFontSize: 16,
    text: forgotPasswordString,
    color: 'rgba(0, 160, 225, 100)',
    mobileColor: 'rgba(0, 160, 225, 100)',
    margin: {
      marginTop: 10,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
  }
}
